exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-body[data-v-3e1692aa]{background:#f0f0f0;max-width:100%;min-height:100vh}.filter-btn[data-v-3e1692aa]{color:#fff}.filter-label[data-v-3e1692aa]{font-size:18px;color:#333}", ""]);

// exports
